module.exports = __webpack_public_path__ + "img/logo-white.cad2d264.png";